/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationParameterDto } from './EvaluationParameterDto';
import {
    EvaluationParameterDtoFromJSON,
    EvaluationParameterDtoFromJSONTyped,
    EvaluationParameterDtoToJSON,
} from './EvaluationParameterDto';
import type { ParameterCombinationDto } from './ParameterCombinationDto';
import {
    ParameterCombinationDtoFromJSON,
    ParameterCombinationDtoFromJSONTyped,
    ParameterCombinationDtoToJSON,
} from './ParameterCombinationDto';

/**
 * 
 * @export
 * @interface WorkStepPreviewDto
 */
export interface WorkStepPreviewDto {
    /**
     * 
     * @type {string}
     * @memberof WorkStepPreviewDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkStepPreviewDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkStepPreviewDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkStepPreviewDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkStepPreviewDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ParameterCombinationDto}
     * @memberof WorkStepPreviewDto
     */
    combination?: ParameterCombinationDto;
    /**
     * 
     * @type {Array<EvaluationParameterDto>}
     * @memberof WorkStepPreviewDto
     */
    evaluations?: Array<EvaluationParameterDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkStepPreviewDto
     */
    isExecutable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkStepPreviewDto
     */
    readonly workStepPreviewId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkStepPreviewDto
     */
    $type?: WorkStepPreviewDtoTypeEnum;
}


/**
 * @export
 */
export const WorkStepPreviewDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoWorkStepPreviewDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.WorkStepPreviewDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type WorkStepPreviewDtoTypeEnum = typeof WorkStepPreviewDtoTypeEnum[keyof typeof WorkStepPreviewDtoTypeEnum];


/**
 * Check if a given object implements the WorkStepPreviewDto interface.
 */
export function instanceOfWorkStepPreviewDto(value?: unknown): value is WorkStepPreviewDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(WorkStepPreviewDtoTypeEnum)[0];
}

export function WorkStepPreviewDtoFromJSON(json: any): WorkStepPreviewDto {
    return WorkStepPreviewDtoFromJSONTyped(json, false);
}

export function WorkStepPreviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkStepPreviewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'combination': !exists(json, 'combination') ? undefined : ParameterCombinationDtoFromJSON(json['combination']),
        'evaluations': !exists(json, 'evaluations') ? undefined : (json['evaluations'] === null ? null : (json['evaluations'] as Array<any>).map(EvaluationParameterDtoFromJSON)),
        'isExecutable': !exists(json, 'isExecutable') ? undefined : json['isExecutable'],
        'workStepPreviewId': !exists(json, 'workStepPreviewId') ? undefined : json['workStepPreviewId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function WorkStepPreviewDtoToJSON(value?: WorkStepPreviewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'combination': ParameterCombinationDtoToJSON(value.combination),
        'evaluations': value.evaluations === undefined ? undefined : (value.evaluations === null ? null : (value.evaluations as Array<any>).map(EvaluationParameterDtoToJSON)),
        'isExecutable': value.isExecutable,
        '$type': value.$type,
    });
}

